// import React, { useState, useEffect } from "react";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import { Link } from "react-router-dom";
// import { getUseData } from "../../services/authService";
// import { useToast } from "../../Toaster/ToastContext";

// const Profile = () => {
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const { showToast } = useToast();
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     userName: "",
//     password: ""
//   });

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const response = await getUseData();
//         const data = await response.json();
        
//           setUserData(data.user);
          
//           // Split the name into first and last name if available
//           const nameParts = data.user.name ? data.user.name.split(" ") : ["", ""];
          
//           setFormData({
//             firstName: nameParts[0] || "",
//             lastName: nameParts.slice(1).join(" ") || "",
//             email: data.user.email || "",
//             phone: data.user.phone || "",
//             userName: data.user.name || "",
//             password: ""
//           });
//       } catch (error) {
//         showToast(error.message || "An error occurred while fetching user data", "error", "Profile");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUserData();
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Here you would implement the API call to update the user profile
//     // For now, we'll just show a success message
//     showToast("Profile updated successfully", "success", "Profile");
//   };

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="page-header">
//           <div className="page-title">
//             <h4>Profile</h4>
//             <h6>User Profile</h6>
//           </div>
//         </div>
//         {/* /product list */}
//         <div className="card">
//           <div className="card-body">
//             {loading ? (
//               <div className="text-center">Loading...</div>
//             ) : (
//               <form onSubmit={handleSubmit}>
//                 <div className="profile-set">
//                   <div className="profile-head"></div>
//                   <div className="profile-top">
//                     <div className="profile-content">
//                       <div className="profile-contentimg">
//                         <ImageWithBasePath
//                           src={userData?.user_image || "assets/img/customer/customer5.jpg"}
//                           alt="img"
//                           id="blah"
//                         />
//                         <div className="profileupload">
//                           <input type="file" id="imgInp" />
//                           <Link to="#">
//                             <ImageWithBasePath src="assets/img/icons/edit-set.svg" alt="img" />
//                           </Link>
//                         </div>
//                       </div>
//                       <div className="profile-contentname">
//                         <h2>{userData?.name || "User"}</h2>
//                         <h4>Updates Your Photo and Personal Details.</h4>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-lg-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label className="form-label">First Name</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="firstName"
//                         value={formData.firstName}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-lg-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label className="form-label">Last Name</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="lastName"
//                         value={formData.lastName}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-lg-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label>Email</label>
//                       <input
//                         type="email"
//                         className="form-control"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-lg-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label className="form-label">Phone</label>
//                       <input 
//                         type="text" 
//                         name="phone"
//                         value={formData.phone}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-lg-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label className="form-label">User Name</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="userName"
//                         value={formData.userName}
//                         onChange={handleInputChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-lg-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label className="form-label">Password</label>
//                       <div className="pass-group">
//                         <input
//                           type="password"
//                           className="pass-input form-control"
//                           name="password"
//                           value={formData.password}
//                           onChange={handleInputChange}
//                         />
//                         <span className="fas toggle-password fa-eye-slash" />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-12">
//                     <button type="submit" className="btn btn-submit me-2">
//                       Submit
//                     </button>
//                     <Link to="#" className="btn btn-cancel">
//                       Cancel
//                     </Link>
//                   </div>
//                 </div>
//               </form>
//             )}
//           </div>
//         </div>
//         {/* /product list */}
//       </div>
//     </div>
//   );
// };

// export default Profile;

import React, { useState, useEffect, useRef } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { getUseData } from "../../services/authService";
import { useToast } from "../../Toaster/ToastContext";
import Loader from '../loader/loader';

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { showToast } = useToast();
  const hasFetched = useRef(false);
  const capitalizeFirstLetter = (str) => {
    if (!str || str === "N/A") return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      if (hasFetched.current) return;
      try {
        setLoading(true);
        const response = await getUseData();
        const data = await response.json();
        setUserData(data.user);
      } catch (error) {
        showToast(error.message || "An error occurred while fetching user data", "error", "Profile");
      } finally {
        setLoading(false);
        hasFetched.current = true;
      }
    };
    fetchUserData();
  }, []);

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper" style={{ position: 'relative', minHeight: '100vh' }}>
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>Profile</h4>
              <h6>User Profile</h6>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="profile-set">
                <div className="profile-head"></div>
                <div className="profile-top">
                  <div className="profile-content">
                    <div className="profile-contentimg">
                      <ImageWithBasePath
                        src={userData?.image || "assets/img/profiles/avator1.png"}
                        alt="img" id="blah"
                      />
                    </div>
                    <div className="profile-contentname">
                      <h2>{capitalizeFirstLetter(userData?.name) || "User"}</h2>
                      <h4>Your Personal Details</h4>
                    </div>
                  </div>
                </div>
                <div className="row" style={{marginTop: '45px', marginLeft: '20px'}}>
                  <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">Name</label>
                      <p>{capitalizeFirstLetter(userData?.name) || "N/A"}</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">Email</label>
                      <p>{capitalizeFirstLetter(userData?.email) || "N/A"}</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">Phone</label>
                      <p>{userData?.phone || "N/A"}</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">User Type</label>
                      <p>{capitalizeFirstLetter(userData?.user_type) || "N/A"}</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">Status</label>
                      <p>{capitalizeFirstLetter(userData?.status) || "N/A"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
